import { tabs } from '../../../constants';

// Only allow dashes and alphanumeric characters in url label
export function slugify(portfolioName = '', portfolioId) {
    const portName = portfolioName
        .trim()
        .toLowerCase()
        .replace(/[^\w]+/gi, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');

    if (portName) {
        return `/${tabs.FOLDERS}/${portName}/${portfolioId}/`;
    }

    return `/${tabs.FOLDERS}/${portfolioId}/`;
}
